export function getToday () {
  const today = new Date()
  const year = today.getFullYear()
  let month = today.getMonth() + 1 // 月份从0开始，需要加1
  if (month < 10) {
    month = '0' + month
  }
  let day = today.getDate()
  if (day < 10) {
    day = '0' + day
  }

  return year + '-' + month + '-' + day
}
